import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["recovery-methods"]!;

export function Body() {
  return (
    <>
      <p>
        Massage, compression socks, ice baths, stretching: there is no shortage of ways to
        recover after a hard run. A meta-analysis of 99 studies compared them.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers in France collected studies of recovery methods after exercise, including
        active recovery, massage, compression garments, cold water, contrast baths,
        cryotherapy, electrical stimulation and stretching. They looked at muscle soreness in
        the following days, how tired people felt, and markers of muscle damage and
        inflammation in the blood.
      </p>

      <h2>What they found</h2>
      <p>
        Active recovery, massage, compression garments, cold water, contrast baths and
        cryotherapy reduced muscle soreness, from a little to a lot. The other methods made no
        difference.
      </p>
      <p>
        Massage had the largest effect on both soreness and feeling tired. Compression garments
        and water immersion also reduced the feeling of fatigue. Massage and cold reduced
        markers of inflammation the most.
      </p>

      <h2>What it means for you</h2>
      <p>
        If you are sore after a race or a hard session, massage is the best documented choice.
        Compression garments and a cold bath can help too, and an easy jog or walk is free.
        Stretching feels good for many people, but it did not reduce soreness.
      </p>
      <p>
        None of these replace what recovery is mainly about: easy days, enough sleep and
        enough food.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The study measured soreness, fatigue and blood markers in the days after exercise. It
        doesn't show whether any of the methods make you fitter over weeks and months, or
        whether they let you train more.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training plans the easy days and asks how you feel before each session. If you are
        still sore from a hard run, say so, and the next session takes it into account.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Dupuy et al. (2018), An evidence-based approach for choosing post-exercise recovery
          techniques to reduce markers of muscle damage, soreness, fatigue, and inflammation: a
          systematic review with meta-analysis.{" "}
          <a href="https://doi.org/10.3389/fphys.2018.00403">Frontiers in Physiology</a>.
        </li>
      </ul>
    </>
  );
}
